const removeDuplicates = (things, uniqueField) => {
  const unique = things.filter(
    (thing, index, self) => index === self.findIndex(t => t[uniqueField] === thing[uniqueField]),
  );
  return unique;
};

export default removeDuplicates;
